module.exports = __webpack_public_path__ + "img/jnkjy.19463d12.jpg";